import {
  TextField,
  Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

/**
 * InfoTextField is a wrapper around TextField that appends an info icon with a tooltip
 * to the label.
 *
 * @param {object} props
 * @param {string} props.label The field label.
 * @param {string} props.tooltip Tooltip text to display on hover.
 * @return {JSX.Element} The rendered TextField with info icon.
 */
function InfoTextField({ label, tooltip, ...props }) {
  return (
    <TextField
      {...props}
      label={
        <span>
          {label}
          <Tooltip title={tooltip}>
            <InfoIcon sx={{ fontSize: 16, ml: 0.5, verticalAlign: 'middle' }} />
          </Tooltip>
        </span>
      }
    />
  );
}

/**
 * Computes n choose k.
 *
 * @param {number} n Total items.
 * @param {number} k Selections.
 * @return {number} The combination result.
 */
function combination(n, k) {
  if (k > n) return 0;
  if (k === 0 || k === n) return 1;
  let result = 1;
  for (let i = 1; i <= k; i++) {
    result = (result * (n - i + 1)) / i;
  }
  return result;
}

export { InfoTextField, combination };